import { Skeleton } from '@common/components';
import { cn } from '@core/utils';

export const RealtimeRegionInfoSkeleton = () => {
  return (
    <section>
      <div className="px-28 pb-16">
        <Skeleton className="mb-8 h-24 w-140 rounded-xsmall" />
        <div className="flex items-center justify-between">
          <Skeleton className="h-16 w-220 rounded-xsmall" />
          <Skeleton className="h-14 w-80 rounded-xsmall" />
        </div>
      </div>

      <div className="px-20">
        <div
          className="rounded-large bg-Gray-white"
          style={{ boxShadow: '8px 10px 40px 0px rgba(0, 0, 0, 0.03)' }}
        >
          {[0, 1, 2].map((index) => (
            <div
              key={index}
              className={cn(
                'flex items-center justify-between px-20',
                index === 0 && 'pt-16',
                index > 0 && 'pt-12',
                index < 2 && 'border-b border-Gray-50 pb-12',
                index === 2 && 'pb-16',
              )}
            >
              <div className="flex flex-1 items-center gap-4">
                <Skeleton className="size-16 rounded-pill" />
                <Skeleton className="h-16 flex-1 rounded-xsmall" />
              </div>
              <Skeleton className="size-16 rounded-xsmall" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
